import { useEffect, useState } from 'react'
import { FC, invalidateQuery, useCQuery } from '../../Services'

export const usePrepayment = (prepaymentId, codClienteNeroneDefault) => {
  const [prepayment, setPrepayment] = useState()
  const { data: objPrepayment, isSuccess } = useCQuery(['prepayment', prepaymentId])
  const { data: agencies = [] } = useCQuery(['environments'])

  useEffect(() => {
    isSuccess && setPrepayment(objPrepayment)
  }, [isSuccess, objPrepayment])

  const setPrepaymentProp = (prop, value) =>
    setPrepayment({ ...prepayment, [prop]: value })

  return [{
    ...prepayment,
    type: prepayment?.type || 'Chiamata',
    bookingType: prepayment?.bookingType || 'CheckIn',
    prepaymentPnrs: prepayment?.prepaymentPnrs?.map(pnr => ({
      ...pnr,
      status: pnr.status || 'OK'
    })) || [],
    environmentId: prepayment?.environmentId || (codClienteNeroneDefault ? agencies.find(({ codClienteNerone }) => codClienteNerone === codClienteNeroneDefault)?.id : ''),
    startDate: prepayment?.startDate
  }, setPrepaymentProp, isSuccess]
}

export const savePrepayment = async (prepayment) => {
  // MANCA IL CONTROLLO SU reason che però è un elenco che ci deve dare mauro bolla
  if (!prepayment.startDate || !prepayment.environmentId) {
    window.growl.show({ severity: 'error', summary: 'Errore', detail: 'Inserire campi obbligatori' })
    return false
  }
  if (prepayment.id === 'new') {
    delete prepayment.id
    try {
      const res = await FC.service('prepayment').create({ ...prepayment })
      await Promise.all(prepayment.prepaymentPnrs
        .filter(pnr => !pnr.deleted && pnr.pnr)
        .map(pnr => FC.service('prepaymentPnr').create({ ...pnr, prepaymentId: res.id })))
      invalidateQuery(['prepayment', 'prepayment'])
      window.growl.show({ severity: 'success', summary: 'Success', detail: 'Salvataggio effettuato' })
      return res
    } catch (e) {
      window.growl.show({ severity: 'error', summary: 'Errore', detail: 'Errore Salvataggio' })
      return false
    }
  }
  await Promise.all(prepayment.prepaymentPnrs.filter(pnr => pnr.id && (pnr.deleted || pnr.pnr === ''))
    .map(pnr => FC.service('prepaymentPnr').remove(pnr.id)))
  try {
    const res = await FC.service('prepayment').patch(prepayment.id, prepayment)
    await Promise.all(prepayment.prepaymentPnrs
      .filter(pnr => !pnr.deleted && !pnr.id && pnr.pnr)
      .map(pnr =>
        pnr.id
          ? FC.service('prepaymentPnr').patch(pnr.id, { ...pnr, prepaymentId: res.id })
          : FC.service('prepaymentPnr').create({ ...pnr, prepaymentId: res.id })
      ))
    invalidateQuery(['prepayment', 'prepayment'])
    window.growl.show({ severity: 'success', summary: 'Success', detail: 'Salvataggio effettuato' })
    return res
  } catch (e) {
    window.growl.show({ severity: 'error', summary: 'Errore', detail: 'Errore Salvataggio' })
    return false
  }
}

export const deletePrepayment = async (prepaymentId) => {
  const res = await FC.service('prepayment').remove(prepaymentId)
  invalidateQuery(['prepaymentList', 'prepayment'])
  window.growl.show({ severity: 'success', summary: 'Success', detail: 'Eliminazione effettuata' })
  return res
}
